export const assessmentTemplate = [
  {
    _id: "0008",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-015T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "epworthSleepinessScale",
      omniTypeVersion: 1,
      title: "The Epworth Sleepiness Scale",
      purpose: "Sleepiness Scale",
      description:
        "The Epworth Sleepiness Scale is widely used in the field of sleep medicine as a subjective measure of a patient's sleepiness. The test is a list of eight situations in which you rate your tendency to become sleepy on a scale of 0, no chance of dozing, to 3, high chance of dozing. When you finish the test, add up the values of your responses. Your total score is based on a scale of 0 to 24. The scale estimates whether you are experiencing excessive sleepiness that possibly requires medical attention.",
      duration: "About 5 minutes",
      directions:
        "How likely are you to doze off or fall asleep in the following situations? You should rate your chances of dozing off, not just feeling tired. Even if you have not done some of these things recently try to determine how they would have affected you. For each situation, decide which option is true.",
      attribution:
        "Reference: Johns MW. A new method for measuring daytime sleepiness: The Epworth Sleepiness Scale. Sleep 1991; 14(6):540-5.",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "epworth1",
          numberText: "1",
          text: "How likely are you to doze off or fall asleep while sitting and reading?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth2",
          numberText: "2",
          text: "How likely are you to doze off or fall asleep while watching TV?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth3",
          numberText: "3",
          text: "How likely are you to doze off or fall asleep while sitting inactive in a public place (e.g., a theater or a meeting)?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth4",
          numberText: "4",
          text: "How likely are you to doze off or fall asleep as a passenger in a car for an hour without a break?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth5",
          numberText: "5",
          text: "How likely are you to doze or fall asleep while lying down to rest in the afternoon when circumstance permit?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth6",
          numberText: "6",
          text: "How likely are you to doze or fall asleep while sitting and talking to someone?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth7",
          numberText: "7",
          text: "How likely are you to doze or fall asleep while sitting quietly after a lunch without alcohol?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to continue to the next question",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "epworth8",
          numberText: "8",
          text: "How likely are you to doze or fall asleep in a car, while stopped for a few minutes in traffic?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Select the most appropriate option to finish",
          answerOptions: [
            {
              value: "0",
              text: "No chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "1",
              text: "Slight chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "2",
              text: "Moderate chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "3",
              text: "High chance of dozing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "epworthSleepinessScale",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
